export default {"src":"/_next/static/media/our-dna-circular.3014c933.svg","height":138,"width":138,"blurWidth":0,"blurHeight":0};